import React, {useState} from "react";
import { Box, Button, Modal, ModalActions, ModalContent, ModalTitle, Typography } from "@deere/fuel-react"

export const SpecialAwardsDialog = ({specialAwards = []}) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    return (
        <>
            <Button size="small" onClick={openModal}>View More</Button>
            <Modal
                open={isOpen}
                onClose={closeModal}
                maxWidth="sm"
                fullWidth={true}
            >
                <ModalTitle onClose={closeModal}>
                    Special Awards
                </ModalTitle>
                <ModalContent>
                    <Box mb={1} mt={1} sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px'
                    }}>
                        {specialAwards.map((award) => (
                            <Box key={award.description} sx={{display: 'flex', gap: '5px'}}>
                                <Typography fontWeight="semibold">{award.description}</Typography>
                                -
                                <Typography>{award.fiscalYear}</Typography>
                            </Box>
                        ))}
                    </Box>
                </ModalContent>
                <ModalActions>
                    <Button onClick={closeModal} variant="secondary">
                        Cancel
                    </Button>
                </ModalActions>
            </Modal>
        </>
    )
}